import { CSSProperties } from "react";
import { useNavigate } from "react-router-dom";

import { QuoteRequestLineDto } from "#modules/quoteRequestLines/infra/fetchQuoteRequestLine.api";
import { usePredictProcessSteps } from "#modules/quoteRequestLines/views/usePredictProcessSteps";
import { ROUTES } from "#shared/routes";
import { Button } from "#shared/view/designSystem/Button";

export const EstimateButton = ({
  quoteRequestLine,
  style,
  ...props
}: {
  quoteRequestLine: QuoteRequestLineDto;
  style?: CSSProperties;
}) => {
  const navigate = useNavigate();

  const navigateToQuoteRequest = () => {
    navigate(ROUTES.partnerQuoteRequest(quoteRequestLine.quoteRequestId));
  };

  const { predictProcessSteps, isPending } = usePredictProcessSteps({
    onSuccess: () => {
      navigateToQuoteRequest();
    },
  });

  return (
    <Button
      style={style}
      loading={isPending}
      onClick={() =>
        predictProcessSteps({
          quoteRequestLineId: quoteRequestLine.id,
          shouldHandleAssembly: true,
          failedOrUnStartedChildrenOnly: false,
        })
      }
      {...props}
    >
      {"Estimer le coût"}
    </Button>
  );
};
